{
  "page": {
    "title": "Rubrics",
    "description": "Weights must total 100. Editing a rubric with recorded scores automatically creates a new version.",
    "create": {
      "title": "Create rubric",
      "description": "Start with one 100-point criterion, then refine the criteria through the API-backed rubric editor.",
      "namePlaceholder": "Rubric name",
      "defaultItemName": "Overall score",
      "submit": "Create",
      "failed": "Could not create rubric.",
      "created": "Rubric created."
    }
  },
  "editor": {
    "loading": "Loading…",
    "empty": "No rubrics yet.",
    "description": "Weights must total 100. If this rubric already has recorded scores, saving clones a new version instead of changing what was already scored.",
    "versionLabel": "Version name",
    "versionLabelPlaceholder": "e.g. Preliminary, Final",
    "versionLabelSave": "Save version name",
    "versionLabelSaved": "Version name updated.",
    "versionLabelFailed": "Could not update the version name.",
    "name": "Name",
    "namePlaceholder": "Criterion name",
    "itemDescription": "Definition (optional)",
    "itemDescriptionPlaceholder": "Describe what this criterion measures and performance expectations, to keep judges consistent",
    "anchors": {
      "title": "Scoring bands (optional)",
      "help": "Describe what each score range looks like, with examples. Judges can expand it while scoring, which narrows the gap between judges.",
      "min": "Band lowest score",
      "max": "Band highest score",
      "description": "Band description",
      "placeholder": "e.g. Outstanding: complete and original",
      "add": "Add band",
      "remove": "Remove"
    },
    "weight": "Weight (%)",
    "scoreRange": "Score range",
    "minScore": "Min score",
    "maxScore": "Max score",
    "remove": "Remove",
    "addCriterion": "Add criterion",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "scaleNote": "Totals are out of 100: each criterion counts as score ÷ its own maximum × weight, so criteria can be scored 0 to 10 or 0 to 100, and may differ from one another.",
    "totalWeightValid": "Total weight: {{total}}% (valid)",
    "totalWeightInvalid": "Total weight: {{total}}% (must equal 100%)",
    "save": "Save changes",
    "saving": "Saving…",
    "saved": "Rubric updated.",
    "saveFailed": "Could not save the rubric."
  }
}
